import { HttpClient } from "@angular/common/http";
import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, ChangeDetectorRef } from "@angular/core";
import { Observable } from "rxjs";
import * as FileSaver from "file-saver";

import {
  ManifestService,
  Manifest,
  ViewService,
  ListViewDelegate,
  SearchParams,
  RouterLinkRenderer,
  DatepickerEditor,
} from "../../common";
import { DatePipe } from "@angular/common";

@Component({
  selector: "manifest-list-view",
  templateUrl: "./manifest-list-view.html",
  styleUrls: ["./manifest-list-view.css"],
  standalone: false,
})
export class ManifestListView implements OnInit, AfterViewInit, ListViewDelegate<Manifest> {
  searchCriteria: string;
  actions: any[];

  private gridApi;
  public columnDefs;
  public defaultColDef;
  public components;
  public frameworkComponents;
  public editType;
  public popupParent: HTMLElement = document.body;
  @ViewChild("agGrid", { read: ElementRef }) agGridElement: ElementRef;
  manifest: Manifest;
  approvalCanceled: boolean = false;
  getRowClass: (params: any) => string;

  constructor(
    public viewService: ViewService,
    public manifestService: ManifestService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    viewService.setViewData({
      pageTitle: "Manifests",
      link: { text: "» New", routeData: ["/manifests/new"] },
      breadcrumbs: false,
    });

    this.initManifestGrid();
  }

  ngOnInit(): void {
    console.log("init ", this.manifest);
  }

  ngAfterViewInit(): void {
    this.popupParent = this.agGridElement?.nativeElement ?? document.body;
    this.cdr.detectChanges();
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  performSearch(searchParams: SearchParams): Observable<Manifest[]> {
    console.log("searchParams: ", searchParams);
    console.log("searchCriteria: ", this.searchCriteria);

    this.searchCriteria = searchParams.search;
    return this.manifestService.filterBy(searchParams);
  }
  exportList() {
    const datepipe: DatePipe = new DatePipe("en-US");
    let formattedDate = datepipe.transform(new Date(), "YYYYMMddHHmmss");
    let searchParams = { search: this.searchCriteria } as SearchParams;
    console.log("searchParams: ", searchParams);
    return this.manifestService.exportList(searchParams).subscribe(
      (resp) => {
        FileSaver.saveAs(resp, `WIMS-MANIFESTS-${formattedDate}.xlsx`);
      },
      async (error) => {
        const message = JSON.parse(await error.error.text()).message;
        console.log(message);
      }
    );
  }

  navigate(params: any): void {
    this.viewService.router.navigate(["/manifests", params]);
  }

  onCellValueChanged(event) {
    if (event.newValue !== event.oldValue) {
      if (!event.node.changedValues) event.node.changedValues = [];

      event.node.changedValues.push(event.colDef.field);
    }
  }

  onRowValueChanged(event) {
    if (event.node.changedValues) {
      console.log(`Changed Values = ${event.node.changedValues.join(",")}`);
      this.save(event.data);
      event.node.changedValues = null;
    }
  }

  onRowSelected(event) {
    if (event.node.selected) {
      this.manifest = event.node.data;
      console.log(this.manifest);
    }
  }

  save(manifest: Manifest) {
    this.manifestService.save(manifest).subscribe(
      (man) => {
        console.log(man);
      },
      (error) => console.log(error)
    );
  }
  onFirstDataRendered() {
    let allColumnIds = [];
    this.gridApi.getColumns().forEach(function (column) {
      allColumnIds.push(column.getColId());
    });
    this.gridApi.autoSizeColumns(allColumnIds, true);
  }

  initManifestGrid() {
    this.editType = "fullRow";
    this.frameworkComponents = {
      datePicker: DatepickerEditor,
      btnCellRenderer: RouterLinkRenderer,
    };

    this.columnDefs = [
      {
        headerName: "Edit",
        field: "trackingNumber",
        cellRenderer: "btnCellRenderer",
        cellRendererParams: {
          editTooltip: "Modify",
          viewTooltip: "Details and Print",
        },
        minWidth: 120,
        maxWidth: 120,
        pinned: "left",
        sortable: false,
        filter: false,
        floatingFilter: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        editable: false,
      },
      {
        headerName: "Tracking No",
        field: "trackingNumber",
        minWidth: 100,
        maxWidth: 150,
        pinned: "left",
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Shipped",
        field: "shipped",
        minWidth: 90,
        sortingOrder: ["asc", "desc"],
        editable: false,
        refData: boolMapping,
      },
      {
        headerName: "Shiping Date",
        field: "shippingDate",
        minWidth: 120,
        filter: "agDateColumnFilter",
        sortingOrder: ["asc", "desc"],
        cellEditor: "datePicker",
        cellRenderer: (data) => {
          return data.value ? new Date(data.value).toLocaleDateString() : "";
        },
      },
      {
        headerName: "Type",
        field: "wasteType",
        minWidth: 90,
        sortingOrder: ["asc", "desc"],
        editable: false,
      },
      {
        headerName: "Generator ID",
        field: "generatorId",
        editable: false,
        minWidth: 120,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Generator Name",
        field: "generatorName",
        editable: false,
        minWidth: 120,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Emcy Phone",
        field: "emergencyPhone",
        editable: false,
        minWidth: 120,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Destination Facility",
        field: "facilityName",
        editable: false,
        minWidth: 220,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Tansporter Company ",
        field: "transporter1Company",
        editable: false,
        minWidth: 180,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Transporter Name ",
        field: "transporterName",
        minWidth: 120,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Transporter Date ",
        field: "transporterDate",
        minWidth: 120,
        filter: "agDateColumnFilter",
        sortingOrder: ["asc", "desc"],
        cellEditor: "datePicker",
        cellRenderer: (data) => {
          return data.value ? new Date(data.value).toLocaleDateString() : "";
        },
      },
    ];
    this.defaultColDef = {
      flex: 1,
      wrapText: true,
      minWidth: 100,
      resizable: true,
      sortable: true,
      floatingFilter: true,
      filter: true,
      autoHeight: true,
      editable: true,
    };
  }
}

let boolMapping = {
  true: "Yes",
  false: "No",
};
